<template>
  <div class="hrt-component">
    <!-- Icon - Using direct shield SVG as requested -->
    <img 
      src="/img/hrt-shield.svg" 
      alt="OnePass Authentication" 
      class="hrt-icon" 
    />

    <!-- Thank You Text -->
    <div class="hrt-content" v-html="renderedThankYouText" />

    <!-- Footer Text -->
    <div class="hrt-disclaimer" v-html="renderedFooterText" />

    <!-- OK Button -->
    <button @click="$emit('ok')" class="hrt-button">
      <i class="fa fa-check">&nbsp;</i>
      OK
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MarkdownIt from "markdown-it";
import type { IconType } from "./types";

const props = defineProps<{
  icon: IconType;
  textThankYou: string;
  textFooter: string;
}>();

defineEmits<{
  (e: "ok"): void;
}>();

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});

const renderedThankYouText = computed(() => {
  return md.render(props.textThankYou);
});

const renderedFooterText = computed(() => {
  return md.render(props.textFooter);
});
</script>

<style lang="scss" scoped>
@use "./styles/hrt.scss";
</style>
